import { Prisma, State } from "@prisma/client";

let therapistLicenseExtensions = {} as ReturnType<typeof getLicenseExtensions>;

const getLicenseExtensions = () => {
  return Prisma.defineExtension((client) => {
    type TherapistIdArgs = {
      therapistId: number;
    };

    type Args<A, S> = TherapistIdArgs & Prisma.Exact<A, Omit<S, "where">>;

    return client.$extends({
      model: {
        therapistLicense: {
          async findPrimary<
            T extends Prisma.TherapistLicenseDelegate,
            A extends Omit<Prisma.TherapistLicenseFindFirstArgs, "where">,
          >(args: Args<A, Prisma.TherapistLicenseFindFirstArgs>) {
            const { therapistId, ...rest } = args as TherapistIdArgs & A;

            const primaryLicense = await client.therapistLicense.findFirst({
              where: {
                therapistId,
                isPrimary: true,
              },
              ...(rest as any),
            });

            return primaryLicense as Prisma.Result<T, A, "findFirst">;
          },

          async findActiveLicenseForState<
            T extends Prisma.TherapistLicenseDelegate,
            A extends Omit<Prisma.TherapistLicenseFindFirstArgs, "where">,
          >(
            args: Args<A, Prisma.TherapistLicenseFindFirstArgs> & {
              state: State;
            },
          ) {
            const { therapistId, state, ...rest } = args as TherapistIdArgs &
              A & { state: State };

            const now = new Date();
            const licenseForState = await client.therapistLicense.findFirst({
              where: {
                therapistId,
                state,
                AND: [
                  {
                    OR: [{ activeDate: null }, { activeDate: { lte: now } }],
                  },
                  {
                    OR: [{ expireDate: null }, { expireDate: { gt: now } }],
                  },
                ],
              },
              ...(rest as any),
            });

            return licenseForState as Prisma.Result<T, A, "findFirst">;
          },
        },
      },
    });
  });
};

if (!process.browser) {
  therapistLicenseExtensions = getLicenseExtensions();
}

export default therapistLicenseExtensions;
